import { ImportantInfoCard } from "./importantInfoCard.component";
import { ApiSchemaPatient } from "../../../models/api/patient";
import { CaseMangerCard } from "./caseManagerCard.component";
import { FormsCard } from "./formsCard.component";
import { SpecialInstructionCard } from "./specialInstructionCard.component";

type Props = {
  data: ApiSchemaPatient | undefined;
  isValidating: boolean;
};

export const PersonalInformation = (props: Props) => (
  <div className="row gx-0 g-lg-2 g-md-2">
    <div className="col-md-6 col-lg-6 col-12 mb-3">
      <ImportantInfoCard {...props} />
    </div>
    <div className="col-md-6 col-lg-6 col-12 mb-1">
      <CaseMangerCard {...props} />
      <FormsCard {...props} />
      <SpecialInstructionCard {...props} />
    </div>
  </div>
);
